import { createThemedStyles } from "@/lib/functions/styles";
import { alpha } from "@mui/material";
var drawerWidth = 0;
var stylesCreator = function (theme) {
    var _a, _b, _c, _d;
    return ({
        appBar: (_a = {
                boxShadow: "none",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
            },
            _a[theme.breakpoints.up("sm")] = {
                width: "calc(100% - ".concat(drawerWidth, "px)"),
                marginLeft: drawerWidth,
            },
            _a),
        title: {
            flexGrow: 1,
            alignItems: "center",
            display: "flex",
            textDecoration: "none",
        },
        image: {
            objectFit: "contain",
            marginRight: "10px",
        },
        menuButton: (_b = {
                marginRight: theme.spacing(2)
            },
            _b[theme.breakpoints.up("sm")] = {
                display: "none",
            },
            _b),
        button: {
            marginTop: theme.spacing(3),
            marginLeft: theme.spacing(1),
        },
        grow: {
            flexGrow: 1,
        },
        search: (_c = {
                position: "relative",
                borderRadius: theme.shape.borderRadius,
                backgroundColor: alpha(theme.palette.common.white, 0.15),
                "&:hover": {
                    backgroundColor: alpha(theme.palette.common.white, 0.25),
                },
                marginRight: theme.spacing(2),
                marginLeft: 0,
                width: "100%"
            },
            _c[theme.breakpoints.up("sm")] = {
                width: "auto",
            },
            _c),
        searchIcon: {
            padding: theme.spacing(0, 2),
            height: "100%",
            position: "absolute",
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        inputRoot: {
            color: "inherit",
        },
        inputInput: (_d = {
                padding: theme.spacing(1, 1, 1, 0),
                paddingLeft: "calc(1em + ".concat(theme.spacing(4), ")"),
                transition: theme.transitions.create("width"),
                width: "100%"
            },
            _d[theme.breakpoints.up("md")] = {
                width: "20ch",
            },
            _d),
    });
};
export default createThemedStyles(stylesCreator);
